import TabletopCanvasMouseEvent from "../events/TabletopCanvasMouseEvent";
import TabletopCanvasNavigationController from "./TabletopCanvasNavigationController";
import TabletopShapeElement from "../../objects/element/TabletopShapeElement";
import TabletopUniverse from "../../objects/TabletopUniverse";
import TabletopViewport from "../../objects/TabletopViewport";
import { Point2d } from "../../../../common/geometry/Geom2d";

export default class TabletopCanvasManipulateTerrainController extends TabletopCanvasNavigationController {
    private _candidateTerrainElement: TabletopShapeElement | null = null;
    private _targetTerrainElement: TabletopShapeElement | null = null;

    public constructor(viewport: TabletopViewport, universe: TabletopUniverse) {
        super(viewport, universe);
    }

    public override dispose(): void {
        if (this._candidateTerrainElement != null) {
            this._candidateTerrainElement.highlightEdges = false;
        }
        if (this._targetTerrainElement != null) {
            this._targetTerrainElement.highlightEdges = false;
        }

        super.dispose();
    }

    public selectTerrainAtPoint(point: Point2d): TabletopShapeElement | null {
        const candidates = this._universe.backgroundElements
            .filter((element) => element instanceof TabletopShapeElement)
            .filter((element) => {
                if (element instanceof TabletopShapeElement) {
                    const containsMousePoint = element.containsPoint(point);

                    return containsMousePoint;
                }

                return false;
            });

        return candidates.length === 0
            ? null
            : (candidates[candidates.length - 1] as TabletopShapeElement);
    }

    public override onCanvasMouseMove(e: TabletopCanvasMouseEvent): void {
        super.onCanvasMouseMove(e);

        const newCandidate = this.selectTerrainAtPoint({
            x: e.universePosition.x,
            y: e.universePosition.y,
        });

        if (newCandidate !== this._candidateTerrainElement) {
            if (this._candidateTerrainElement != null) {
                this._candidateTerrainElement.highlightEdges = false;
            }

            if (newCandidate != null) {
                newCandidate.highlightEdges = true;
            }

            this._candidateTerrainElement = newCandidate;
        }
    }

    public override onCanvasMouseDrag(e: TabletopCanvasMouseEvent): void {
        if (e.altKey) {
            super.onCanvasMouseDrag(e);
            return;
        }

        if (this._targetTerrainElement == null) {
            return;
        }

        const delta: Point2d = {
            x: e.movement.x / this._viewport.magnificationX,
            y: e.movement.y / this._viewport.magnificationY,
        };

        if (!(delta.x === 0 && delta.y === 0)) {
            this._targetTerrainElement.move(delta);
        }
    }

    public override onCanvasMouseDown(e: TabletopCanvasMouseEvent): void {
        if (this._targetTerrainElement != null) {
            this._targetTerrainElement.highlightEdges = false;
        }

        this._targetTerrainElement =
            this._candidateTerrainElement ??
            this.selectTerrainAtPoint(e.universePosition);

        if (this._targetTerrainElement != null) {
            this._targetTerrainElement.highlightEdges = true;
        }
    }

    public override onCanvasMouseUp(e: TabletopCanvasMouseEvent): void {
        if (this._targetTerrainElement != null) {
            this._targetTerrainElement.highlightEdges = false;
        }
        this._targetTerrainElement = null;
    }
}
